/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { Component, Fragment, Link } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Title from '../shared/Title';
import MasterResults from '../shared/MasterResults';
import { mp, getCampaign, withCommas } from '../../constants/utils';
import {
  resultTypes,
  OPTIMUM_AGE_ANALISIS_PRICE,
  DISCOUNTED_PENSION_PLAN_PRICE,
} from '../../constants/constants';
import FinautaTable from '../shared/FinautaTable';
import Bullets from '../shared/Bullets';
import GetStartedWithExample from '../shared/GetStartedWithExample';
import { PENSION_PLAN_PRICE } from '../../constants/constants';
import Text from '../shared/Text';
import {
  historialLaboral,
  pensionActual,
  pensionMejoradaBase,
  pensionMejoradaMaxima,
  escenario2,
  inversion,
} from './tables';
import { palette, flexColumn, breakpoints } from '../../constants/styles';
import Icon from '../shared/Icon';
import RiskFactor from '../shared/RiskFactor';
import Division from '../shared/Division';
import { StyledGreenSpan } from '../shared/resultsStyles';

const StickySection = styled.div`
  margin-bottom: 20px;
`;

const StyledBullets = css`
  margin-bottom: 80px;
`;

const stickySections = [
  {
    customSection: (
      <StickySection
        key={'InfoGeneral'}
        id="InfoGeneral"
        titleLevel={4}
        title="Información General"
      >
        <Title level={4} color={palette.primaryColor} style={{ alignSelf: 'flex-start' }}>
          Vigencia de derechos
        </Title>
        <Text type="body2" style={{ marginBottom: '20px' }}>
          <b>Actualmente cuentas con vigencia de derechos</b> para recibir los servicios médicos que
          brinda el Instituto Mexicano del Seguro Social (IMSS). Asimismo, cuentas con los
          requisitos mínimos para realizar Modalidad 40.
        </Text>
        <Title level={4} color={palette.primaryColor} style={{ alignSelf: 'flex-start' }}>
          Tu historial laboral
        </Title>
        <Text type="body2" style={{ marginBottom: '20px' }}>
          Según los registros del IMSS, has trabajado con <b>5 empleadores</b> distintos y tienes un
          total de <b>940 semanas cotizadas</b> (ver reporte de semanas cotizadas adjunto).
        </Text>
      </StickySection>
    ),
  },
  {
    id: 'PensionActual',
    titleLevel: 4,
    sectionTitle: 'Pensión Actual',
    tableTitle: null,
    tableDescription: (
      <>
        Tu pensión estará entre <b>$3,746 y $5,032 mensuales</b> dependiendo de tu edad de
        jubilación, manteniendo tu actual <b>salario de cotización de $146</b> diarios. Esto con
        base en la Ley del IMSS de 1973.
      </>
    ),
    table: pensionActual,
  },
  {
    customSection: (
      <StickySection
        key={'AhorrarOInvertir'}
        id="PensionMejorada"
        titleLevel={4}
        title="Pensión Mejorada"
      >
        {getTitleDescriptionTable(
          'Escenario 1 - Modalidad 40',
          <>
            Con base en tu <b>capacidad de pago mensual de $3,000</b>, tu pensión en Modalidad 40
            podría estar entre <b>$12,334 y $21,652</b> mensuales dependiendo de tu edad de
            jubilación.
          </>,
          pensionMejoradaBase,
        )}
        <Division />
        {getTitleDescriptionTable(
          'Escenario 2 - Modalidad 40',
          <>
            Realizando <b>aportaciones máximas de $4,500</b> al IMSS, tu pensión en Modalidad 40
            podría estar entre <b>$18,409 y $32,493</b> mensuales dependiendo de tu edad de
            jubilación.
          </>,
          escenario2,
        )}
        <Division />
        {getTitleDescriptionTable(
          'Escenario 3 - Modalidad 40',
          <>
            Realizando <b>aportaciones máximas de $6,652</b> al IMSS, tu pensión en Modalidad 40
            podría estar entre <b>$27,235 y $48,098</b> mensuales dependiendo de tu edad de
            jubilación.
          </>,
          pensionMejoradaMaxima,
        )}
      </StickySection>
    ),
  },
  {
    id: 'InversionMejorarPension',
    titleLevel: 4,
    sectionTitle: 'Inversión requerida',
    tableTitle: null,
    tableDescription: (
      <>
        Suponiendo que realizas{' '}
        <b>
          aportaciones en <i>Modalidad 40</i> durante 5 años
        </b>
        , en el Escenario 1 tu inversión acumulada será de <b>$180,000</b> y tardarás
        <b> 10.8 meses</b> en recuperar tu inversión. En el Escenario 2 tu inversión acumulada será
        de <b>$270,000</b> y tardarás
        <b> 9.8 meses</b> en recuperar tu inversión. Mientras que, en el Escenario 3 (máximo) tu
        inversión acumulada será de <b>$399,144</b> y tardarás{' '}
        <b> 9.3 meses en recuperar tu inversión</b>.
      </>
    ),
    table: inversion,
  },
  {
    customSection: (
      <StickySection
        key={'EdadOptima'}
        id="EdadOptima"
        titleLevel={4}
        title="Edad óptima de pension"
      >
        <Text type="body2" style={{ marginBottom: '1em' }}>
          Para determinar tu{' '}
          <b>edad óptima de pensión es necesario realizar un análisis financiero</b> que considere
          tu:
        </Text>

        <ul style={{ alignSelf: 'flex-start', marginTop: '0px' }}>
          <li>
            <Text type="body2" style={{ marginBottom: '0.5em' }}>
              Estilo de vida en el retiro
            </Text>
          </li>
          <li>
            <Text type="body2" style={{ marginBottom: '0.5em' }}>
              Necesidad de liquidez
            </Text>
          </li>
          <li>
            <Text type="body2" style={{ marginBottom: '0.5em' }}>
              Esperanza de vida
            </Text>
          </li>
          <li>
            <Text type="body2" style={{ marginBottom: '0.5em' }}>
              Aversión al riesgo
            </Text>
          </li>
          <li>
            <Text type="body2" style={{ marginBottom: '0.5em' }}>
              Costo de oportunidad
            </Text>
          </li>
        </ul>
        <Text type="body2" style={{ marginBottom: '1em' }}>
          <b>¿Te interesa?</b> Pide tu análisis financiero durante tu asesoría. Tiene un{' '}
          <u>costo extra</u> de{' '}
          <b>
            <StyledGreenSpan>${OPTIMUM_AGE_ANALISIS_PRICE}</StyledGreenSpan>
          </b>
        </Text>
      </StickySection>
    ),
  },
  {
    customSection: (
      <StickySection
        key={'Factores-de-riesgo'}
        id="Factores-de-riesgo"
        titleLevel={4}
        title="Factores de riesgo"
      >
        <RiskFactor
          riskFactor={{
            title: 'Faltante de semanas de cotización',
            icon: 'missing',
            color: 'red',
            currentStatus: 'Alto riesgo',
            explanation:
              'En algunos casos, el IMSS puede accidentalmente omitir semanas cotizadas. Por lo tanto, es importante validar semanas cotizadas y empleadores.',
            notes:
              'Comenzaste a cotizar en 1979 pero tu primer semana de cotización registrada es en 1982, por lo que te podrían faltar hasta 156 semanas de cotización.',
          }}
        />
        <RiskFactor
          riskFactor={{
            title: 'Problemas en datos de identidad',
            icon: 'identityProblems',
            color: palette.secondaryColor,
            currentStatus: 'Bajo riesgo',
            explanation:
              'Cualquier error en tus datos puede limitar tu posibilidad de pensionarte. Algunos ejemplos son 1) CURP desvinculado de tu NSS; 2) Cuentas con mas de un NSS; 3) Tu nombre es incorrecto ante el IMSS; etc.',
            notes: '',
          }}
        />
        <RiskFactor
          riskFactor={{
            title: 'Vigencia de derechos',
            icon: 'vigenciaDeDerechos',
            color: palette.secondaryColor,
            currentStatus: 'Bajo riesgo',
            explanation:
              'Para pensionarte es necesario cumplir con los requisitos de pensión y tener vigencia de derechos.',
            notes: 'Tus derechos están vigentes.',
          }}
        />
      </StickySection>
    ),
  },
  {
    customSection: (
      <StickySection key="CTA" id="CTA" titleLevel={5} title="¿Te gustó el plan de ejemplo?">
        <Title level={4} color={palette.terciaryColor}>
          ¡Solicita tu plan de pensión!
        </Title>
        <Bullets
          bulletStyles={css`
            margin-bottom: 15px;
          `}
          customTextSize="1.35rem"
          bullets={[
            'Cálculo detallado de pensión actual',
            '3 escenarios para mejorar tu pensión con Mod. 40',
            'Análisis costo beneficio de tu inversión',
            'Identificación de riesgos laborales',
          ]}
        />
        <Title level={4} style={{ marginBottom: '10px' }} color={palette.terciaryColor}>
          Formas de pago
        </Title>
        <Text type="body2" styles={StyledBullets}>
          Puedes pagar en OXXO o bancos en efectivo o con tarjeta de crédito/débito online con
          Mercado Pago.
        </Text>
      </StickySection>
    ),
  },
];

function getTitleDescriptionTable(title, description, table) {
  return (
    <Fragment>
      {title && (
        <Title level={5} color={palette.terciaryColor} align="left" style={{ width: '100%' }}>
          {title}
        </Title>
      )}
      {description && <Text type="body2">{description}</Text>}
      <FinautaTable
        titlesAlignment={table.titlesAlignment}
        tableDescription={table.tableDescription}
        table={table.table}
      />
    </Fragment>
  );
}

function getStickySection(id, titleLevel, sectionTitle, tableTitle, tableDescription, table) {
  return (
    <StickySection key={id} id={id} titleLevel={titleLevel} title={sectionTitle}>
      {getTitleDescriptionTable(tableTitle, tableDescription, table)}
    </StickySection>
  );
}

const ExamplePlan = ({ match }) => (
  <MasterResults
    type={resultTypes.STICKY}
    id="ExamplePlan"
    showCTA={true}
    CTALink={
      match.params.referralId
        ? `/retiro/contacto/5989130/028d8e1b-c13e-46be-b561-24a8665f10cb/${match.params.referralId}`
        : `/retiro/contacto/5989130/c88927a2-f2a0-4a3d-9642-0463ca882121`
    }
    CTAText="Solicitar plan"
    resultId="Plan de prueba"
    showStickySubtitle
    stickySubtitleText="Plan de ejemplo"
  >
    {stickySections.map(section =>
      !section.customSection
        ? getStickySection(
            section.id,
            section.titleLevel,
            section.sectionTitle,
            section.tableTitle,
            section.tableDescription,
            section.table,
          )
        : section.customSection,
    )}
  </MasterResults>
);

ExamplePlan.propTypes = {
  onSlideChange: PropTypes.func,
};

ExamplePlan.defaultProps = {
  onSlideChange: () => {},
};

export default ExamplePlan;
